import request from '@/utils/request'
//公司产品
export const getProductList = () => request.get('/official/product/list')
